/**
 * 上报规则检验
 * author:brian author 2022 05 20
 */
// import * as validator from '@/utils/validate.js';

import { channelMask } from '../ownRules.js'

export function DeviceRule() {
    return {
        alarmPeriod: [{ required: true, message: $t('integration.duration_cannot_be_empty'), trigger: 'blur' },
        {
            validator: channelMask,
            trigger: 'blur'
        }
        ],
        alarmInterval: [{ required: true, message: $t('integration.time_cannot_be_empty'), trigger: 'blur' },
        {
            validator: channelMask,
            trigger: 'blur'
        }
        ],
    }
}